<template>
  <div class="Content">

    <form @submit.prevent="login" >
      <input v-model="user.email" name="email" id="email" type="text"> <br>
      <input v-model="user.password" name="password" id="password" type="text"> <br>
      <input type="submit">
    </form>

  </div>
</template>

<script>
  import toastr from 'toastr'

  import { login as authLogin } from 'src/vuex/actions/authActions'
  import { userAuthenticated } from 'src/vuex/getters'

  export default{
    vuex: {
      getters: { userAuthenticated },
      actions: { authLogin }
    },
    data () {
      return {
        user: {}
      }
    },
    watch: {
      'userAuthenticated' (value) {
        if (value === true) {
          toastr.success('Bienvenue')
          this.$router.go('/')
        }
      }
    },
    methods: {
      login () {
        this.authLogin({ email: this.user.email, password: this.user.password })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LoginView.vue?e4d4e57a